module.exports = __webpack_public_path__ + "static/media/skills.e0a2379e.jpg";